// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#mtpStatusFlaggedModal .btn {
  border-radius: 30px;
  min-width: 115px;
  box-shadow: none !important;
}
#mtpStatusFlaggedModal .btn-link {
  color: #5b5b5b;
  font-weight: bold;
}
#mtpStatusFlaggedModal .btn-link:hover {
  text-decoration: none;
  color: #5a5a5a;
}
#mtpStatusFlaggedModal .btn-link:focus {
  text-decoration: none;
}
#mtpStatusFlaggedModal .btn-secondary {
  border-radius: 0;
  background-color: #b4b4b4;
  box-shadow: none !important;
  border: none;
}
#mtpStatusFlaggedModal .btn-primary {
  border-radius: 30px;
  min-width: 115px;
  box-shadow: none !important;
}
@media (min-width: 2024px) {
#mtpStatusFlaggedModal #confirmation-modal-label {
    font-size: 3.2rem;
}
}
#mtpStatusFlaggedModal .invalid-feedback {
  display: block;
}
@media (min-width: 2024px) {
#mtpStatusFlaggedModal .invalid-feedback span {
    font-size: 1.84rem !important;
}
}
@media (min-width: 2024px) {
#mtpStatusFlaggedModal .modal-dialog {
    max-width: 700px !important;
}
}
@media (min-width: 2024px) {
#mtpStatusFlaggedModal .modal-dialog .input-group input {
    font-size: 1.84rem !important;
}
}
@media (min-width: 2024px) {
#mtpStatusFlaggedModal .modal-dialog .modal-footer button.btn {
    font-size: 1.84rem !important;
}
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
